// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-radio[data-v-387b1728] {\n  height: 30px;\n}", ""]);
// Exports
module.exports = exports;
